<template>
    <div>
      <div class="title-box" @click="goSearch">
        <search-head :isDisabled="true" searchType="homePage"></search-head>
      </div>
      <div class="content-box-bg">
        <img class="content-bg" src="../../assets/images/homepage-bg.png" />
        <div class="content-box">
          <div class="codes-query query-entry" @click="scanBarcode">
            <img src="../../assets/images/entry/scan-codes.png" alt="" />
            <div class="query-entry-text">
              <div class="fs34 bold">扫描查询</div>
              <div class="fs22">扫描商品条码查找</div>
            </div>
          </div>
          <div class="classify-query query-entry" @click="goClassify">
            <img src="../../assets/images/entry/classify.png" alt="" />
            <div class="query-entry-text">
              <div class="fs34 bold">分类查询</div>
              <div class="fs22">通过分类快速查找</div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="collect-and-history">
        <img src="../../assets/images/shading.png" class="bg-shading" alt="" />
        <van-tabs class="collect-history-tabs" v-model="activeName" @click="onClick">
          <van-tab title="我的收藏" name="collect">
            <div v-if="collectList.length === 0" class="no-result">
              <img src="../../assets/images/empty/no-data.png" alt="" />
              <span class="no-result-text">您暂无收藏</span>
            </div>
            <div v-else class="goods-box">
              <goods-show :goodsList="collectList" idType="productId"></goods-show>
            </div>
          </van-tab>
          <van-tab class="collect-history-tab" title="浏览记录" name="history">
            <div v-if="historyList.length === 0" class="no-result">
              <img src="../../assets/images/empty/no-data.png" alt="" />
              <span class="no-result-text">您暂无浏览记录</span>
            </div>
            <div v-else class="goods-box">
              <goods-show :goodsList="historyList" idType="productId"></goods-show>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      
    </div>
</template>

<script>
    import searchHead from './components/searchHead'
    import goodsShow from './components/goodsShow'
    import axios from 'axios'
    import apiConfig from '@/api'
    export default {
      name: 'retail',
      data () {
        return {
          activeName: 'collect',
          uid: '',
          collectList: [],
          historyList: [],
        }
      },
      components:{
        searchHead,
        goodsShow
      },
      created(){
      },
      mounted() {
          const _this = this;
          console.log('window.cordova..:', window.cordova);
          setTimeout(function() {
              document.addEventListener("deviceready", function() {
                  if (window.cordova) {
                    window.cordova.exec(function (success) {
                      _this.uid = success.uid;
                      localStorage.setItem('uid', success.uid);
                      _this.getCollectList();
                    }, function () {
                    }, "MideaUser", "getUser", []);
                  }
              });
          }, 1000)
      },
      methods:{
        scanBarcode() {
          const _this = this;
          setTimeout(function() {
            document.addEventListener("deviceready", function() {
              if (window.cordova) {
                window.cordova.exec(function (success) {
                  _this.getScan(success.text);
                }, function () {
                  // alert("Error: " + error);
                }, "MideaBarcode", "scan", []);
              }
            });
          }, 300)
        },
        getScan(result) {
          const url = apiConfig.serverAddress + apiConfig.scan;
          const restParams = {
            barCode: result // result  '3116310077619182H00034'
          }
          const headers = {
            'Content-Type': "application/json",
            __TokenAuthorization_UserName_:'admin',
            __TokenAuthorization_Function_:'refreshClassificationLevelAndSort'
          }
          axios  //axios请求体BODY上为model
          .post(url, {'restParams':restParams, headParams: {userKey: ""}}, { headers: headers })
          .then(res => {
            this.$router.push({
              name: 'app',
              query: {
                id: res.data.data.id
              },
            });
//          this.$router.push(`/app`);
//          this.$route.query.id = res.data.data.id;
          });
        },
        onClick(name) {
          if (name === 'collect') {
            this.getCollectList();
          } else {
            this.getHistoryList();
          }
        },
        getCollectList() {
          const url = apiConfig.serverAddress + apiConfig.myCollections;
          const restParams = {
            openId: this.uid, // this.uid   '12312'
            needImgHttps: 1,
          }
          const headers = {
            'Content-Type': "application/json",
            __TokenAuthorization_UserName_:'admin',
            __TokenAuthorization_Function_:'refreshClassificationLevelAndSort'
          }
          axios  //axios请求体BODY上为model
          .post(url, {'restParams':restParams, headParams: {userKey: ""}}, { headers: headers })
          .then(res => {
            this.collectList = res.data.data ? res.data.data : [];
          });
        },
        getHistoryList() {
          const url = apiConfig.serverAddress + apiConfig.myBrowsingHistory;
          const restParams = {
            needImgHttps: 1,
            pageNo: 1,
            pageSize: 9999,
            openId: this.uid,  // this.uid   'oLXj80APNhtZR2DbnGrCAHROCN4U'
          }
          const headers = {
            'Content-Type': "application/json",
            __TokenAuthorization_UserName_:'admin',
            __TokenAuthorization_Function_:'refreshClassificationLevelAndSort'
          }
          axios  //axios请求体BODY上为model
          .post(url, {'restParams':restParams, headParams: {userKey: ""}}, { headers: headers })
          .then(res => {
            this.historyList = res.data.data ? res.data.data : [];
          });
        },
        goSearch() {
          this.$router.push({
            name: 'retail-search',
            query: {},
          });
        },
        goClassify() {
          this.$router.push({
            name: 'retail-category',
            query: {},
          });
        }
      }
    }
</script>


<style scoped>
  .title-box {
    background-color: rgb(144,185,252);
    position: relative;
  }
  .content-box-bg {
    width: 100vw;
    position: relative;
  }
  .content-bg {
    width: 100vw;
    height: 750px;
  }
  .content-box {
    margin: 32px 32px 40px;
    width: calc(100% - 64px);
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 0;
    left: 0;
  }
   .query-entry {
    width: 331px;
    height: 160px;
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .query-entry  img {
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }
  .codes-query {
    background-color: rgb(235,242,254);
    color: #3377FF;
  }
  .classify-query {
    background-color: rgb(246,249,254);
    color: #FF7E32;
  }
  .fs34 {
    font-size: 34px;
  }
  .fsss {
    font-size: 22px;
  }
  .bold {
    font-weight: 700;
  }
  .collect-and-history {
    width: 94%;
    position: absolute;
    top: 350px;
    left: 3%;
    background: #ffffff;
    border-radius: 24px;
    height: calc(100vh - 350px - 50px);
    overflow: hidden;
  }
  .no-result {
    width: 100%;
    text-align: center;
  }
  .no-result img {
    width: 360px;
    height: 280px;
    margin-top: 200px;
  }
  .no-result  .no-result-text {
    display: block;
    margin-top: 36px;
    font-size: 28px;
    color: rgba(0, 0, 0, 45%);
  }
  .goods-box {
    height: calc(100vh - 350px);
    overflow-y: auto;
  }
  .tab-title {
    font-size: 50px;
    font-weight: 400;
  }
  .collect-history-tabs >>> .van-tab__text--ellipsis {
    font-size: 35px;
    overflow: inherit;
  }
  .collect-history-tabs >>> .van-tabs__wrap {
    width: 60%;
  }
  .bg-shading {
    width: 216px;
    height: 122px;
    position: absolute;
    top: 0;
    right: 40px;
    z-index: 3;
  }
</style>



// WEBPACK FOOTER //
// src/pages/retail/index.vue